import { ElementRef, Inject, Injector, Input, OnInit, Optional, Renderer2, Directive } from '@angular/core';
import { TransitionOptions } from '@uirouter/angular';
import { FiStateSrefNavigateCheck, FiStateSrefClickHandler } from './state-sref.inject';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Directive()
export class StateSrefBase implements OnInit {
    @Input('fiStateSref') stateSref: string;
    @Input('fiStateSrefParams') stateSrefParams: any;

    protected fiStateService: FiStateService;

    constructor(
        private injector: Injector,
        @Optional() @Inject(FiStateSrefClickHandler) protected clickHandler,
        @Optional() @Inject(FiStateSrefNavigateCheck) protected stateSrefNavigateCheck: () => true | (() => true)[],
    ) {
        this.fiStateService = injector.get(FiStateService);
    }

    ngOnInit(): void {
        // we should add click event listener to the end of queue, because we want to check if event was prevented by previous listeners
        const elementRef = this.injector.get(ElementRef),
            renderer = this.injector.get(Renderer2);
        renderer.listen(elementRef.nativeElement, 'click', this.onClick.bind(this));
    }

    navigate(options?: TransitionOptions) {
        this.fiStateService.go(this.stateSref, this.stateSrefParams, options);
    }

    getUrl() {
        return this.fiStateService.href(this.stateSref, this.stateSrefParams);
    }

    onClick($event: MouseEvent) {
        if (this.clickHandler) {
            if (Array.isArray(this.clickHandler)) {
                this.clickHandler.forEach((cb) => cb($event));
            } else {
                this.clickHandler($event);
            }
        }

        if (this._checkNavigate() && !$event.defaultPrevented) {
            this.navigate();
        }
    }

    _checkNavigate() {
        if (!this.stateSrefNavigateCheck) {
            return true;
        }

        if (Array.isArray(this.stateSrefNavigateCheck)) {
            return this.stateSrefNavigateCheck.every((cb) => cb() === true);
        } else {
            return this.stateSrefNavigateCheck();
        }
    }
}
